export interface BookmarkRequest {
  itemId: string;
  offset: number;
  seasonId?: string;
  episodeId?: string;
  mode?: Mode;
  videoId?: string;
  snum?: number;
  epnum?: number;
  cty?: string;
}

export enum Mode {
  EPISODE = 'episode',
  SERIES = 'series',
  PLAYLIST = 'playlist',
}
